import { render, staticRenderFns } from "./versionSubmit.vue?vue&type=template&id=8221bd22&"
import script from "./versionSubmit.vue?vue&type=script&lang=js&"
export * from "./versionSubmit.vue?vue&type=script&lang=js&"
import style0 from "./versionSubmit.vue?vue&type=style&index=0&id=8221bd22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports